(function() {
    /**
     * Session Storage
     */
    window.c24SessionStorageSet = function(name, value) {
        try { sessionStorage.setItem(name, value); } catch (e) { console.log(e); }
    };

    window.c24SessionStorageGet = function(name) {
        try { return sessionStorage.getItem(name); } catch (e) { console.log(e); }
        return null;
    };

    window.c24SessionStorageRemove = function(name) {
        try { sessionStorage.removeItem(name); } catch (e) { console.log(e); }
    };


    /**
     * Local Storage
     */
    window.c24LocalStorageSet = function(name, value) {
        try { localStorage.setItem(name, value); } catch (e) { console.log(e); }
    };

    window.c24LocalStorageGet = function(name) {
        try { return localStorage.getItem(name); } catch (e) { console.log(e); }
        return null;
    };

    window.c24LocalStorageRemove = function(name) {
        try { localStorage.removeItem(name); } catch (e) { console.log(e); }
    };
})();
